/** Logo de Revolution Inc. (archivo oficial del brand kit) + el producto. `tono` = color del fondo donde va. */
export function Logo({ tono = "oscuro", compacto = false }: { tono?: "oscuro" | "claro"; compacto?: boolean }) {
  const src = tono === "oscuro" ? "/brand/revolution-inc-horizontal-blanco.png" : "/brand/revolution-inc-horizontal-negro.png";
  return (
    <span className="flex items-center gap-3">
      <img src={src} alt="Revolution Inc." width={96} height={22} className="h-6 w-auto" />
      {!compacto && <span className={`eyebrow hidden border-l pl-3 sm:inline ${tono === "oscuro" ? "border-white/20 text-acero" : "border-borde text-tinta-suave"}`}>Wealth Nation · Tu diseño patrimonial</span>}
    </span>
  );
}
